import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_j8frta4jec: FaireBrandEntity = {
  token: "b_j8frta4jec",
  type: "brand",
  name: "Beam Organics",
  avatarUrl:
    "https://cdn.faire.com/fastly/7601666d9615018fdc0d9882e40f7de18c5a92820cbcda9b3fa6e1fbaeadf6aa.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/dfdb4981910350659a2b30b95be291433347deed1fac8a82520fd214db6eddcb.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/7601666d9615018fdc0d9882e40f7de18c5a92820cbcda9b3fa6e1fbaeadf6aa.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/dfdb4981910350659a2b30b95be291433347deed1fac8a82520fd214db6eddcb.jpeg",
  location: "Boston, MA, USA",
  minimumOrderDollars: 200,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "At Beam, we believe nutrition should be simple, enjoyable, and effective. That’s why we create great-tasting, science-backed supplements that fit effortlessly into your daily routine. Whether you're an athlete, a busy parent, or a wellness enthusiast, our products are designed to fuel your body and support your goals—without the guesswork.\n\nAs we continue to grow, we're expanding our trusted, best-in-class supplements, deepening our relationships with our customers, and working with the people who inspire them. Our mission remains the same: to make nutrition easy, delicious, and an anticipated part of any wellness routine.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:05.249Z",
    importedBy: "entity-db-cli",
  },
};
